class DynamicSavingsWidget {
  constructor() {
    this.widget = null;
    this.MINIMUM_ORDER_AMOUNT = 40;
    this.SHIPPING_FEE = 9.95;
    this.DISCOUNT_TIERS = [
      { order: 1, discount: 0.25 },
      { order: 2, discount: 0.15 },
      { order: 3, discount: 0.10 },
    ];
    this.SPECIFIC_COLLECTION_HANDLE = 'west';
    this.cartTotal = 0;
  }

  init() {
    this.createWidgetElement();
    this.checkVisibility();
    this.setupFormMonitoring();
    this.updateCartTotal(); // Initial update
  }

  createWidgetElement() {
    this.widget = document.createElement('div');
    this.widget.id = 'dynamic-savings-widget';
    this.widget.style.display = 'none';
    this.widget.innerHTML = `
      <div class="banner-wrapper" style="height: 80px; background: #000;">
        <div class="banner-content" style="position: fixed; top: 0; left: 0; right: 0; background: #000; color: #fff; padding: 12px 24px; z-index: 999; pointer-events: auto;">
          <div style="max-width: 1200px; margin: 0 auto; display: flex; justify-content: space-between; align-items: center;">
            <div style="flex: 1;">
              <p style="font-size: 16px; font-weight: 600; margin: 0 0 4px 0;">
                Subscribe and save up to $<span id="total-savings">0.00</span> on your first 3 orders!
              </p>
              <p style="font-size: 14px; margin: 0;">
                <span style="font-weight: 600;">FREE DELIVERY</span> on your first order ($${this.SHIPPING_FEE.toFixed(2)} value)!
              </p>
            </div>
            <div style="display: flex; align-items: center; gap: 12px;">
              <button id="see-breakdown" 
                style="background: #fff; color: #000; padding: 8px 16px; border-radius: 4px; font-weight: 600; border: none; cursor: pointer; transition: opacity 0.2s;">
                See breakdown
              </button>
              <button id="close-widget" 
                style="background: none; border: none; color: #fff; padding: 8px; cursor: pointer; font-size: 20px; line-height: 1;">
                ×
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.prepend(this.widget);

    const seeBreakdownBtn = document.getElementById('see-breakdown');
    seeBreakdownBtn.addEventListener('mouseover', () => seeBreakdownBtn.style.opacity = '0.8');
    seeBreakdownBtn.addEventListener('mouseout', () => seeBreakdownBtn.style.opacity = '1');

    document.getElementById('see-breakdown').addEventListener('click', () => this.showBreakdown());
    document.getElementById('close-widget').addEventListener('click', () => this.hideWidget());
  }

  setupFormMonitoring() {
    this.productForms = {};
    
    const setupForm = (form) => {
      const formId = form.getAttribute('id') || Math.random().toString(36).substr(2, 9);
      const priceElement = form.querySelector('.price-item--regular');
      const quantityInput = form.querySelector('input[name="quantity"]');
      
      if (priceElement && quantityInput) {
        const price = parseFloat(priceElement.textContent.replace(/[^0-9.]/g, ''));
        
        this.productForms[formId] = {
          price: price,
          quantity: parseInt(quantityInput.value, 10) || 0
        };

        const updateQuantity = () => {
          this.productForms[formId].quantity = parseInt(quantityInput.value, 10) || 0;
          this.updateCartTotal();
        };

        quantityInput.addEventListener('change', updateQuantity);
        quantityInput.addEventListener('input', updateQuantity);

        form.querySelectorAll('button[name="plus"], button[name="minus"]').forEach(button => {
          button.addEventListener('click', () => {
            setTimeout(updateQuantity, 100);
          });
        });
      }
    };

    document.querySelectorAll('form[action="/cart/add"]').forEach(setupForm);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            node.querySelectorAll('form[action="/cart/add"]').forEach(setupForm);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  updateCartTotal() {
    this.cartTotal = Object.values(this.productForms).reduce((total, product) => {
      return total + (product.price * product.quantity);
    }, 0);
    
    console.log('Updated cart total:', this.cartTotal);
    this.updateSavings();
  }

  checkVisibility() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const discountCode = Shopify.checkout?.discount?.code || '';
    const pathSegments = window.location.pathname.split('/');
    const collectionHandle = pathSegments[pathSegments.indexOf('collections') + 1];

    if ((utmSource === 'subscribe_offer' || discountCode === 'SUBSCRIBE25') && 
        collectionHandle === this.SPECIFIC_COLLECTION_HANDLE) {
      this.showWidget();
    }
  }

  showWidget() {
    this.widget.style.display = 'block';
    document.body.style.paddingTop = '80px';
  }

  hideWidget() {
    this.widget.style.display = 'none';
    document.body.style.paddingTop = '0';
  }

  updateSavings() {
    console.log('Updating savings with cart total:', this.cartTotal);
    let totalSavings = 0;

    if (this.cartTotal >= this.MINIMUM_ORDER_AMOUNT) {
      totalSavings = this.DISCOUNT_TIERS.reduce((acc, tier, index) => {
        const tierSavings = this.cartTotal * tier.discount;
        console.log(`Tier ${tier.order} savings:`, tierSavings);
        return acc + tierSavings + (index === 0 ? this.SHIPPING_FEE : 0);
      }, 0);
    }

    console.log('Total savings calculated:', totalSavings);
    const savingsElement = document.getElementById('total-savings');
    if (savingsElement) {
      savingsElement.textContent = totalSavings.toFixed(2);
    } else {
      console.error('Total savings element not found');
    }
  }

  showBreakdown() {
    const modalHTML = `
      <div id="savings-modal" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000;">
        <div style="background: white; padding: 24px; border-radius: 8px; max-width: 400px; width: 90%; position: relative;">
          <button onclick="document.getElementById('savings-modal').remove()" 
            style="position: absolute; right: 16px; top: 16px; background: none; border: none; font-size: 24px; cursor: pointer;">×</button>
          <h2 style="margin: 0 0 16px 0; font-size: 20px; font-weight: 600;">Savings Breakdown</h2>
          ${this.DISCOUNT_TIERS.map((tier, index) => `
            <div style="margin-bottom: 16px;">
              <p style="margin: 0 0 4px 0; font-weight: 600;">Order ${tier.order}: ${tier.discount * 100}% off</p>
              <p style="margin: 0; color: #666;">
                Savings: $${(this.cartTotal * tier.discount).toFixed(2)}
                ${index === 0 ? ` + $${this.SHIPPING_FEE.toFixed(2)} (Free Delivery)` : ''}
              </p>
            </div>
          `).join('')}
          <div style="margin-top: 24px; padding-top: 16px; border-top: 1px solid #eee;">
            <p style="margin: 0 0 8px 0; font-weight: 600;">
              Total Savings: $${(this.cartTotal >= this.MINIMUM_ORDER_AMOUNT ? 
                this.DISCOUNT_TIERS.reduce((acc, tier, index) => 
                  acc + (this.cartTotal * tier.discount) + (index === 0 ? this.SHIPPING_FEE : 0), 0
                ) : 0).toFixed(2)}
            </p>
            <p style="margin: 0 0 4px 0; font-size: 14px; color: #666;">
              *Minimum order amount: $${this.MINIMUM_ORDER_AMOUNT}
            </p>
            <p style="margin: 0; font-size: 14px; color: #666;">
              *Free delivery ($${this.SHIPPING_FEE.toFixed(2)}) included in first order savings
            </p>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }
}

// Initialize the widget
document.addEventListener('DOMContentLoaded', () => {
  const widget = new DynamicSavingsWidget();
  widget.init();
});







